var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Rating',{attrs:{"increment":+_vm.increment,"maxRating":+_vm.maxRating,"active-color":_vm.active_color,"inactive-color":_vm.inactive_color,"star-size":+_vm.star_size,"value":_vm.modelValue},on:{"input":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }